module.exports = __webpack_public_path__ + "static/media/crm.57f85846.png";